import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Tooltip } from 'primeng/tooltip';
import { RetailerService } from '../../../services/retailer.service';
import { RetailerTopBarComponent } from '../retailer-top-bar/retailer-top-bar.component';

@Component({
    selector: 'app-retailer-home',
    imports: [
        RetailerTopBarComponent,
        Tooltip
    ],
    templateUrl: './retailer-home.component.html',
    styleUrl: './retailer-home.component.scss'
})
export class RetailerHomeComponent implements OnInit {

    public turningLightsOn = false;
    public turningLightsOff = false;

    constructor(private retailerService: RetailerService,
                private messageService: MessageService) {
    }

    public ngOnInit(): void {
        this.prefetchVehicleModelOverview();
    }

    public async lightsOnAll(): Promise<void> {
        if (this.turningLightsOn || this.turningLightsOff) return;
        this.turningLightsOn = true;
        try {
            await this.retailerService.turnAllLightsOn();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'All lights turned on.' });
        } catch (e) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to turn lights on.' });
            console.error(e);
        } finally {
            this.turningLightsOn = false;
        }
    }

    public async lightsOffAll(): Promise<void> {
        if (this.turningLightsOn || this.turningLightsOff) return;
        this.turningLightsOff = true;
        try {
            await this.retailerService.turnLightsOff();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'All lights turned off.' });
        } catch (e) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to turn lights off.' });
            console.error(e);
        } finally {
            this.turningLightsOff = false;
        }
    }

    private prefetchVehicleModelOverview(): void {
        this.retailerService.getVehicleModels('').then();
    }

}
